// ============================================================
// src/shack/shackPersistence.js
// Persistencia del Shack en Firestore
// ============================================================

import {
  obtenerShack,
  guardarShack,
  cargarCertificadosDisponibles,
  combinarItemsShack,
  serializarItemsParaGuardar,
} from './shackDatos.js';

export async function cargarEstadoShack(uid) {
  const shack = await obtenerShack(uid);
  const disponibles = await cargarCertificadosDisponibles(uid);

  const items = combinarItemsShack(disponibles, shack?.items || []);

  return {
    shack,
    disponibles,
    items,
  };
}

export async function guardarEstadoShack(uid, items) {
  const payload = {
    items: serializarItemsParaGuardar(items),
    actualizadoEn: Date.now(),
  };

  await guardarShack(uid, payload);
}

export function serializarEstadoShack(items) {
  return serializarItemsParaGuardar(items);
}